export default __webpack_public_path__ + "static/BasisGrotesque-Light-c4182fe52a91d8a3093151440b7ab2bb.woff2";